/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React, { FC } from "react"
import { Container } from "@carrotfertility/carotene"
import { Body } from "../../atoms/Bodies"
import { SupportCenterLinks } from "../../../../utils/SupportCenterLinks"
import { ZendeskArrowLink } from "../../atoms/links/ZendeskArrowLink"
import { Spacer } from "../../atoms/Atoms"
import { DbgPaths } from "../../../../utils/Paths"
import { TextLink } from "../../atoms/links/TextLink"
import { FormattedMessage } from "react-intl"

export type ExternalDeductibleInformationalProps = {
  costShare: boolean
}

const ExternalDeductibleInformational: FC<ExternalDeductibleInformationalProps> = ({ costShare }) => {
  return (
    <>
      <Container padding="none" stack="small">
        <Body color="black-80">
          <FormattedMessage
            defaultMessage="You need to meet your health insurance deductible before you can use Carrot funds for eligible <link>qualified medical expenses</link>."
            values={{
              link: (linkContent) => (
                <TextLink to={DbgPaths.QUALIFIED_MEDICAL_EXPENSES} target="_blank">
                  {linkContent}
                </TextLink>
              )
            }}
          />

          <Spacer height={0.5} />
          {costShare ? (
            <FormattedMessage defaultMessage="Funds you use may also be subject to bank fees, taxes, cost sharing, and other plan details." />
          ) : (
            <FormattedMessage defaultMessage="Funds you use may also be subject to bank fees, taxes, and other plan details." />
          )}
        </Body>
      </Container>
      <ZendeskArrowLink supportCenterLink={SupportCenterLinks.HOW_DOES_CARROT_WORK_WITH_MY_INSURANCE}>
        <FormattedMessage defaultMessage="Learn how your insurance deductible works with Carrot" />
      </ZendeskArrowLink>
    </>
  )
}

export { ExternalDeductibleInformational }
